// extracted by mini-css-extract-plugin
module.exports = {"editor":"editorStyles_editor__3ywqN"};